var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.symbol.match.js
// module id = 1092
// module chunks = 0